import { left, right } from '@sweet-monads/either';
import type { Either } from '@sweet-monads/either';

import { AbstractError } from '@/domain/errors/abstract-error.js';
import { ServerError } from '@/domain/errors/server-error.js';
import type { SapConnectionView, TestSapConnectionParams, TestSapConnectionResult, UpsertSapConnectionParams } from '@/domain/models/sap-connection.js';
import type { SapConnectionRepository } from '@/domain/repositories/sap-connection-repository.js';
import type { GetSapConnection, TestSapConnection, UpsertSapConnection } from '@/domain/use-cases/sap-connection.js';

export class GetSapConnectionUseCase implements GetSapConnection {
    constructor(private readonly repository: SapConnectionRepository) {}

    public async execute(clientId: string): Promise<Either<AbstractError, SapConnectionView | null>> {
        try {
            return right(await this.repository.get(clientId));
        } catch (error) {
            if (error instanceof AbstractError) {
                return left(error);
            }
            return left(new ServerError((error as Error).message));
        }
    }
}

export class UpsertSapConnectionUseCase implements UpsertSapConnection {
    constructor(private readonly repository: SapConnectionRepository) {}

    public async execute(clientId: string, params: UpsertSapConnectionParams): Promise<Either<AbstractError, SapConnectionView>> {
        try {
            return right(await this.repository.upsert(clientId, params));
        } catch (error) {
            if (error instanceof AbstractError) {
                return left(error);
            }
            return left(new ServerError((error as Error).message));
        }
    }
}

export class TestSapConnectionUseCase implements TestSapConnection {
    constructor(private readonly repository: SapConnectionRepository) {}

    public async execute(clientId: string, params: TestSapConnectionParams): Promise<Either<AbstractError, TestSapConnectionResult>> {
        try {
            return right(await this.repository.test(clientId, params));
        } catch (error) {
            if (error instanceof AbstractError) {
                return left(error);
            }
            return left(new ServerError((error as Error).message));
        }
    }
}
